import HeadCompats from '../../../../../pages/vip/features/item-status/head.compats.mobile';

export default HeadCompats;
